import { motion } from "framer-motion";
import { MaskedLines } from "./Reveal";

export const PageHero = ({ image, overline, titleLines, text }) => (
  <section className="relative overflow-hidden bg-[#09121F] pt-36 pb-20 sm:pt-44 sm:pb-28">
    <div className="absolute inset-0">
      <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#09121F]/70 via-[#09121F]/85 to-[#09121F]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B1D16]/60 to-transparent" />
    </div>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="text-xs uppercase tracking-[0.3em] font-display font-semibold text-amber-400"
      >
        {overline}
      </motion.p>
      <h1 className="mt-5 font-serif font-semibold tracking-tight leading-[1.06] text-4xl sm:text-5xl lg:text-6xl text-emerald-50 max-w-4xl">
        <MaskedLines lines={titleLines} />
      </h1>
      {text && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.55 }}
          className="mt-6 max-w-2xl text-base sm:text-lg text-slate-300/90 font-light leading-relaxed"
        >
          {text}
        </motion.p>
      )}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="mt-10 h-px w-40 origin-left bg-gradient-to-r from-amber-500 to-transparent"
      />
    </div>
  </section>
);
